const $header = document.querySelector('.header');
const $hero = document.querySelector('.hero');
let $prevScrollpos = window.scrollY;
let $heroHeight = 0;
let $headerHeight = 0;

const getHeights = () => {
    $headerHeight = $header.offsetHeight;
    $heroHeight = $hero ? $hero.offsetHeight - $headerHeight : 0;
}

const showHeader = () => {
    const logoImage = document.querySelector('.header__logo'); // Get the logo image element
    const headerLink = document.querySelector('.header__home'); // Get the link element containing logo data attributes

    if (!logoImage || !headerLink) return; // Ensure the elements exist before proceeding

    if (window.scrollY > $heroHeight) {
        $header.classList.add('header--white');
        
        // Change src to logo for bright background
        logoImage.src = headerLink.getAttribute('data-logo-for-bright');

        if (window.scrollY >= 20) {
            let currentScrollPos = window.scrollY;
            if ($prevScrollpos < currentScrollPos) {
                $header.classList.remove('header--visible');
            } else if ($header != null) {
                $header.classList.add('header--visible');
            }
            $prevScrollpos = currentScrollPos;
        }
    } else {
        if (document.querySelector('.hero')) {
            $header.classList.remove('header--white');
            // Change src to logo for dark background
            logoImage.src = headerLink.getAttribute('data-logo-for-dark');
        }
        
    }
};

const setPosition = () => {
    let threshold;
    if (document.querySelector('.hero')) {
        threshold = $heroHeight;
    } else {
        threshold = 20;
    }

    if (window.scrollY < threshold) {
        $header.classList.remove('header--hidden');
    } else {
        $header.classList.add('header--hidden');
    }
}

getHeights();
showHeader();
setPosition();
window.addEventListener('resize', getHeights);
window.addEventListener('scroll', setPosition);
window.addEventListener('scroll', showHeader);










